import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import { RestApiService } from '@/services'

import { ApplicationState } from '@/state/root.models'
import { setLoadingFullAction } from '@/state/ui/global/slices/index.slices'
import { TwoFactorStatus } from '@/enums/two-factor-status.enum'

import { setTwoFactorVerified } from '@/state/auth/slices/index.slices'
import ActionTypes from '../constants'
import {
  ValidateTwoFactorPayload,
  ValidateTwoFactorResponse,
  UserState,
} from '../models'

const apiService: RestApiService = Container.get(RestApiService)

export const validateCodesThunk = createAsyncThunk(
  ActionTypes.VALIDATE_CODES,
  async (payload: ValidateTwoFactorPayload, thunkAPI) => {
    try {
      apiService.requestParams = {
        method: 'POST',
        endpoint: 'twoFactorAuthentication/validateCode',
        body: payload,
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: ValidateTwoFactorResponse = await apiService.sendAuthData(
        auth.token || '',
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      if (response.isCodeValid && response.isCodeValid) {
        thunkAPI.dispatch(setTwoFactorVerified(true))
      }

      return response
    } catch (error) {
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const validateCodesExtraReducer = (
  builder: ActionReducerMapBuilder<UserState>,
) => {
  builder.addCase(validateCodesThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(validateCodesThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false
    state.twoFactorVerified =
      payload.isCodeValid && payload.isCodeValid
        ? TwoFactorStatus.ACTIVE
        : TwoFactorStatus.ERROR
  })
}

export default validateCodesExtraReducer
